/* eslint-disable array-bracket-newline */
/**
 * Implements MyPositions based on covalent api
 */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { IPriceAlert } from '@kattana-io/common';
import PriceAlertsTable from './Table';
import { IStore } from '../../../reducers';
import PriceAlertsTableMobile from './TableMobile';

interface IMyPositionProps {
  width?: number;
  isMobile?: boolean;
}

/**
 * Parent component used to load tickers before renderings
 * @param props
 */
const PriceAlertsDataLayer = ({ width, isMobile }: IMyPositionProps) => {
  const loading = useSelector((state: IStore) => state.price_alerts.loading);
  const priceAlerts = useSelector(
    (state: IStore) => state.price_alerts.pending
  );
  const tickers = useSelector((state: IStore) => state.price_alerts.tickers);

  const [filter, setFilter] = useState('');

  const data = React.useMemo(() => {
    if (filter == '') {
      return priceAlerts;
    } else {
      return priceAlerts.filter(
        (item: IPriceAlert) => `${item.chain}-${item.pair}` == filter
      );
    }
  }, [priceAlerts, filter]);

  const onSetFilter = (filter: string) => {
    setFilter(filter);
  };

  return isMobile ? (
    <PriceAlertsTableMobile
      tickers={tickers}
      alerts={data}
      filter={filter}
      onFilter={onSetFilter}
      loading={loading}
    />
  ) : (
    <PriceAlertsTable
      tickers={tickers}
      alerts={data}
      filter={filter}
      onFilter={onSetFilter}
      loading={loading}
      width={width}
    />
  );
};

export default PriceAlertsDataLayer;
